import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';
import { AiService } from '../api/agentStep.model';
import { getAiServiceLogoPath, getAiServiceDisplayName } from 'src/app/common/aiServiceUtils';
import { RSA_DEMO_AI_SERVICES } from './rsaDemoAiServices';

const rsaDemoSet = new Set<string>(RSA_DEMO_AI_SERVICES);

export const AiServiceSelectOptions: ISelectOption[] = Object.values(AiService)
  .filter((service) => !rsaDemoSet.has(service))
  .map((service) => ({
    id: `${FilterTypesEnum.AiService}-${service}`,
    value: service,
    displayName: getAiServiceDisplayName(service),
    withoutBeautifyDisplayName: true,
    filterType: FilterTypesEnum.AiService,
    categoryName: FilterTypesEnum.AiService.toString(),
    iconPath: getAiServiceLogoPath(service),
  }))
  .sort((a, b) => a.displayName.localeCompare(b.displayName));

export const AiServiceSelectOptionsWithRsaDemo: ISelectOption[] = Object.values(AiService)
  .map((service) => ({
    id: `${FilterTypesEnum.AiService}-${service}`,
    value: service,
    displayName: getAiServiceDisplayName(service),
    withoutBeautifyDisplayName: true,
    filterType: FilterTypesEnum.AiService,
    categoryName: FilterTypesEnum.AiService.toString(),
    iconPath: getAiServiceLogoPath(service),
  }))
  .sort((a, b) => a.displayName.localeCompare(b.displayName)); // Alphabetical order

const VIOLATION_AI_SERVICES: Set<string> = new Set([
  AiService.m365Copilot,
  AiService.salesforceEinstein,
  AiService.agentforce,
  AiService.copilotStudio,
  AiService.chatGptEnterprise,
  AiService.azureAiFoundry,
  AiService.vertexAi,
  AiService.serviceNow,
  AiService.powerAutomate,
  AiService.powerApps,
  AiService.powerPages,
  AiService.bedrock,
  AiService.bedrockAgentCore,
  AiService.claude,
  AiService.perplexity,
  AiService.cursor,
  AiService.windsurf,
  AiService.tabnine,
  AiService.amazonQ,
  AiService.dia,
  AiService.openaiCodex,
]);

export const ViolationAiServiceSelectOptions: ISelectOption[] = AiServiceSelectOptions.filter((opt) =>
  VIOLATION_AI_SERVICES.has(opt.value)
);
